// Module
var code = "<p>Talk to your health care provider regarding your symptoms, they can discuss medications or other treatments that might help.</p> ";
// Exports
export default code;